import React from 'react';
import {reduxForm} from 'redux-form';
import BaseForm from '../form/base-form';
import FormField from '../form/form-field';
import LocalizedStrings from '../../localization/strings';
import Button from '../button';
import {validateRequiredFields} from '../../utils/form';
import DistanceSelectField from '../stage/distance-select';
import Alert from '../alert';

const fields = ['id', 'code', 'codes_left', 'discount',  'distanceId', 'stageId'];

function validate(values) {
    let errors = {
        _error: null
    };
    errors = validateRequiredFields(values, [
        'code', 'codes_left', 'discount', 'distanceId', 'stageId'
    ], errors);
    return errors;
}

class PromoCodeForm extends BaseForm {

    onStageSelect() {
        const {fields} = this.props;
        fields.distanceId.onChange(null);
    }

    render() {
        const {
            submitting,
            error,
            handleSubmit,
            fields: {
                code,
                codes_left,
                discount,
                stageId,
                distanceId
            }
        } = this.props;
        return (
            <div>
                <form onSubmit={handleSubmit(this.submit.bind(this))}>
                    {error && <Alert type="error">{error}</Alert>}

                    <DistanceSelectField stageField={stageId} distanceField={distanceId} disableStageSelect={false} onStageSelect={this.onStageSelect.bind(this)} onlyThisSeason={true} />

                    <FormField label={LocalizedStrings.code} name="name" field={code}>
                        <input ref="name" placeholder={LocalizedStrings.code} type="text" {...code}/>
                    </FormField>

                    <FormField label={LocalizedStrings.codesLeft} name="codes_left" field={codes_left}>
                        <input ref="codes_left" type="number" placeholder={'0'} {...codes_left}/>
                    </FormField>
                    <FormField label={LocalizedStrings.discount} name="discount" field={discount}>
                        <input ref="discount" type="number" placeholder={'0'} {...discount}/>
                    </FormField>


                    <div className="actions-row">
                        <Button loading={submitting} submit={true} disabled={submitting} type="primary">
                            {LocalizedStrings.submit}
                        </Button>
                    </div>

                </form>
            </div>
        )
    }
}

export default reduxForm({
    form: 'promo-code-form',
    fields,
    validate,
    destroyOnUnmount: true
}, state => ({initialValues: state.promoCodes.promoCode.item}))(PromoCodeForm);



// WEBPACK FOOTER //
// ./src/js/components/promo-code/promo-code-form.js